import React, { useState } from 'react';
import { Table, Input, TimePicker, Select, message } from 'antd';
import dayjs from 'dayjs';
import { updateCheckInOut, createOrUpdateCheckInOut } from '../../../../apis/OdooAttendanceApi';
import './style.css';

const { Option } = Select;

const FormBody = ({ items, setItems, columns }) => {
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record) => record.key === editingKey;

    const handleFieldChange = async (key, field, value) => {
        const newData = [...items];
        const index = newData.findIndex((item) => key === item.key);

        if (index > -1) {
            const item = newData[index];
            const updatedItem = {
                ...item,
                [field]: value,
            };

            newData.splice(index, 1, updatedItem);
            setItems(newData);

            const tieneFecha = updatedItem.fecha && updatedItem.fecha !== '';
            const tieneEntrada = updatedItem.entrada && updatedItem.entrada !== '';
            const tieneSalida = updatedItem.salida && updatedItem.salida !== '';

            if (tieneFecha && tieneEntrada && tieneSalida) {
                await createOrUpdateRecord(updatedItem);
            }
        }
    };

    const createOrUpdateRecord = async (item) => {
        try {
            const fechaBase = dayjs(item.fecha, 'DD/MM/YYYY').format('YYYY-MM-DD');

            const payload = {
                fecha: `${fechaBase}T00:00:00`,
                empleado_id: item.empleado_id,
            };

            if (item.id) {
                payload.id = item.id;
            }

            if (item.entrada) {
                payload.check_in = `${fechaBase}T${item.entrada}:00`;
            }

            if (item.salida) {
                payload.check_out = `${fechaBase}T${item.salida}:00`;
            }

            if (item.estacion_id) {
                payload.estacion_id = item.estacion_id;
            }

            if (item.horario_id) {
                payload.horario_id = item.horario_id;
            }

            if (item.referencia_capturada) {
                payload.referencia = item.referencia_capturada;
            }

            const response = await createOrUpdateCheckInOut(payload);

            if (response.ok) {
                const updatedData = response.payload;
                const newData = [...items];
                const index = newData.findIndex((i) => i.key === item.key);

                if (index > -1) {
                    newData[index] = {
                        ...newData[index],
                        id: updatedData.id,
                        odoo_id: updatedData.odoo_id,
                        entrada: updatedData.check_in ? dayjs(updatedData.check_in).format('HH:mm') : '',
                        salida: updatedData.check_out ? dayjs(updatedData.check_out).format('HH:mm') : '',
                        horas_trabajadas: updatedData.worked_hours || 0,
                        horas_extra: updatedData.overtime_hours || 0,
                        horas_autorizadas: updatedData.validated_overtime_hours || 0,
                        retardo: updatedData.retardo || 0,
                        descanso: updatedData.descanso || 0,
                        festivo: updatedData.festivo || 0,
                        estacion_id: updatedData.estacion_id,
                        horario_id: updatedData.horario_id,
                        referencia_capturada: updatedData.referencia || '',
                        dia: updatedData.tipo_dia_texto || newData[index].dia,
                        tipo_dia: updatedData.tipo_dia || newData[index].tipo_dia,
                    };
                    setItems(newData);
                }

                message.success('Registro guardado y calculado automáticamente');
            }
        } catch (error) {
            console.error('Error al guardar registro:', error);
            message.error('Error al guardar el registro');
        }
    };


    const editableColumns = columns.map((col) => {
        if (['fecha', 'entrada', 'salida', 'estacion'].includes(col.dataIndex)) {
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: true,
                    handleFieldChange,
                }),
            };
        }
        return col;
    });

    // Componente de celda editable
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        record,
        children,
        handleFieldChange,
        ...restProps
    }) => {
        const renderInput = () => {
            switch (dataIndex) {
                case 'fecha':
                    return (
                        <Input
                            value={record[dataIndex]}
                            onChange={(e) => handleFieldChange(record.key, dataIndex, e.target.value)}
                            placeholder="DD/MM/YYYY"
                            style={{ width: '100%' }}
                        />
                    );

                case 'entrada':
                case 'salida':
                    return (
                        <TimePicker
                            value={record[dataIndex] ? dayjs(record[dataIndex], 'HH:mm') : null}
                            onChange={(time) => {
                                const timeStr = time ? time.format('HH:mm') : '';
                                handleFieldChange(record.key, dataIndex, timeStr);
                            }}
                            format="HH:mm"
                            placeholder="Seleccionar hora"
                            style={{ width: '100%' }}
                        />
                    );

                case 'estacion':
                    return (
                        <Select
                            value={record[dataIndex]}
                            onChange={(value) => handleFieldChange(record.key, dataIndex, value)}
                            placeholder="Seleccionar estación"
                            style={{ width: '100%' }}
                        >
                            <Option value="Catálogo">Catálogo</Option>
                            <Option value="Estación 1">Estación 1</Option>
                            <Option value="Estación 2">Estación 2</Option>
                        </Select>
                    );
                default:
                    return children;
            }
        };

        return (
            <td {...restProps}>
                {editing ? renderInput() : children}
            </td>
        );
    };

    const components = {
        body: {
            cell: EditableCell,
        },
    };

    return (
        <Table
            components={components}
            dataSource={items}
            columns={editableColumns}
            pagination={{
                pageSize: 50,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} registros`,
            }}
            scroll={{ x: 'max-content' }}
            bordered
            size="small"
            rowClassName={() => 'table-row-white'}
        />
    );
};

export default FormBody;